/**
 * @generated SignedSource<<d253922c5450d2f3f20434658e3a7235>>
 * @relayHash c963a3eadc65263fb1863622c7c88db0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cb6ffb66726ee179d7224b764429b59b06877112b29331b4d9f698bdea99cec1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavQueueInnerQuery } from './HorizontalNavQueueInnerQuery.graphql';

const node: PreloadableConcreteRequest<HorizontalNavQueueInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cb6ffb66726ee179d7224b764429b59b06877112b29331b4d9f698bdea99cec1",
    "metadata": {},
    "name": "HorizontalNavQueueInnerQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
